
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/localStorage',["require", "exports", '../core/buffer', '../core/browserfs', '../generic/key_value_filesystem', '../core/api_error', '../core/global'], function(require, exports, buffer, browserfs, kvfs, api_error, global) {
    var Buffer = buffer.Buffer, ApiError = api_error.ApiError, ErrorCode = api_error.ErrorCode;

    // Some versions of FF and all versions of IE do not support the full range of
    // 16-bit numbers encoded as characters, as they enforce UTF-16 restrictions.
    // http://stackoverflow.com/questions/11170716/are-there-any-characters-that-are-not-allowed-in-localstorage/11173673#11173673
    var supportsBinaryString = false, binaryEncoding;
    try  {
        global.localStorage.setItem("__test__", String.fromCharCode(0xD800));
        supportsBinaryString = global.localStorage.getItem("__test__") === String.fromCharCode(0xD800);
    } catch (e) {
        // IE throws an exception.
        supportsBinaryString = false;
    }
    binaryEncoding = supportsBinaryString ? 'binary_string' : 'binary_string_ie';

    /**
    * A synchronous key-value store backed by localStorage.
    */
    var LocalStorageStore = (function () {
        function LocalStorageStore() {
        }
        LocalStorageStore.prototype.name = function () {
            return 'LocalStorage';
        };

        LocalStorageStore.prototype.clear = function () {
            global.localStorage.clear();
        };

        LocalStorageStore.prototype.beginTransaction = function (type) {
            // No need to differentiate.
            return new kvfs.SimpleSyncRWTransaction(this);
        };

        LocalStorageStore.prototype.get = function (key) {
            try  {
                var data = global.localStorage.getItem(key);
                if (data !== null) {
                    return new Buffer(data, binaryEncoding);
                }
            } catch (e) {
            }

            // Key doesn't exist, or a failure occurred.
            return undefined;
        };

        LocalStorageStore.prototype.put = function (key, data, overwrite) {
            try  {
                if (!overwrite && global.localStorage.getItem(key) !== null) {
                    // Don't want to overwrite the key!
                    return false;
                }
                global.localStorage.setItem(key, data.toString(binaryEncoding));
                return true;
            } catch (e) {
                throw new ApiError(11 /* ENOSPC */, "LocalStorage is full.");
            }
        };

        LocalStorageStore.prototype.delete = function (key) {
            try  {
                global.localStorage.removeItem(key);
            } catch (e) {
                throw new ApiError(2 /* EIO */, "Unable to delete key " + key + ": " + e);
            }
        };
        return LocalStorageStore;
    })();
    exports.LocalStorageStore = LocalStorageStore;

    /**
    * A synchronous file system backed by localStorage. Connects our
    * LocalStorageStore to our SyncKeyValueFileSystem.
    */
    var LocalStorageFileSystem = (function (_super) {
        __extends(LocalStorageFileSystem, _super);
        function LocalStorageFileSystem() {
            _super.call(this, { store: new LocalStorageStore() });
        }
        LocalStorageFileSystem.isAvailable = function () {
            return typeof global.localStorage !== 'undefined';
        };
        return LocalStorageFileSystem;
    })(kvfs.SyncKeyValueFileSystem);
    exports.LocalStorageFileSystem = LocalStorageFileSystem;

    browserfs.registerFileSystem('LocalStorage', LocalStorageFileSystem);
});
//# sourceMappingURL=localStorage.js.map
;